import React from "react";
import { NavLink } from "react-router-dom";
import logoImg from "../logo.svg";
import { Icon } from "react-icons-kit";
import { menu } from "react-icons-kit/feather/menu";
import { arrowLeft } from "react-icons-kit/feather/arrowLeft";
import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import Sidebar from "../components/Sidebar";
import { useJwt } from "react-jwt";
import {
    EditTagAPI,
    getByIdTag,
    GetProductStatus,
    api_url,
} from "../apiconfig/authService";
import { RiLoaderFill } from "react-icons/ri";
import { toast } from "react-toastify";

function EditTag(props) {
    const navigate = useNavigate();
    const { _, isExpired } = useJwt(localStorage.getItem("accessToken"));
    if (isExpired) navigate("/");

    const setMediaTableViewMessage = props.setMessage;

    const [editedMediaData, setEditedMediaData] = useState({});
    const [loading, setLoading] = useState(false);
    const [editLoading, setEditLoading] = useState(false);

    const { id } = useParams();
    const [statusData, setStatusData] = useState([]);

    useEffect(() => {
        (async () => {
            setLoading(true);
            try {
                const response = await getByIdTag(
                    id,
                    localStorage.getItem("accessToken")
                );
                setLoading(false);
                setEditedMediaData(response.data.response);
            } catch (error) {
                console.log(error);
            } finally {
                setLoading(false);
            }
        })();
    }, []);

    useEffect(() => {
        (async () => {
            setLoading(true);
            try {
                const statusResponse = await GetProductStatus(
                    localStorage.getItem("accessToken")
                );
                setLoading(false);
                setStatusData(statusResponse.data);
            } catch (error) {
                console.log(error);
            } finally {
                setLoading(false);
            }
        })();
    }, []);

    const handleTitleChange = (e) => {
        const temp = { ...editedMediaData };
        temp.title = e.target.value;
        setEditedMediaData(temp);
    };

    const handleStatusChange = (e) => {
        const temp = { ...editedMediaData };
        temp.statusid = e.target.value;
        setEditedMediaData(temp);
    };

    const handleDiscardClick = () => {
        navigate("/tags");
    };

    const handleSubmitClick = async (e) => {
        e.preventDefault();

        try {
            if (editedMediaData.title === "") {
              toast.error("Tag Title is empty!");
              return;
            }
        } catch (error) {
            toast.error(error.message);
            window.scrollTo(0, 0);
            return;
        }

        let response;
        const data = {
            "id": id,
            "title": editedMediaData.title,
            "statusid": editedMediaData.statusid
        }

        try {
            setEditLoading(true);
            response = await EditTagAPI(
                data,
                localStorage.getItem("accessToken")
            );
            if (response.status === 200) {
                setEditLoading(false);
                toast.success("Tag Updated Successfully")
                setMediaTableViewMessage(response.data.message);
                navigate("/tags");
            }
        } catch (err) {
            if (err.response && err.response.data && err.response.data.error) {
                toast.error(err.response.data.error);
                window.scrollTo(0, 0);
            } else {
                toast.error("An error occurred. Please try again later.");
                window.scrollTo(0, 0);
            }
        } finally {
            setEditLoading(false);
        }
    };

    return (
        <div className="dashboard-content">
            <Sidebar />
            <div className="body-cart tab-content dasContent p-4 bg-white rounded">
                <div className="d-flex justify-content-between align-items-start pb-4 border-bottom mb-4">
                    <h1 className="heading h4 mb-0 fw-bold">Edit Tag</h1>
                    <div className="d-inline-flex gap-2">
                        <NavLink to="/media" className="btn btn-primary">
                            View All
                        </NavLink>
                    </div>
                </div>
                {
                    loading ?
                        <div className="d-flex align-items-center justify-content-center">
                            <RiLoaderFill size={40} className="text-success spin-animation text-center" />
                        </div>
                        :
                        <div
                            role="tabpanel"
                            className="personal-info tab-pane active storetab"
                            id="pi"
                        >
                            {/* <h4 className="text-primary h6 fw-bold mb-3">Product main category information</h4> */}
                            <div className="row">
                                <div className="form-group col-sm-12 col-lg-12 mb-3">
                                    <label htmlFor="catName">Title</label>
                                    <input
                                        type="text"
                                        value={editedMediaData?.title || ""}
                                        onChange={handleTitleChange}
                                        className="form-control custom-input my-3"
                                        id="catName"
                                        placeholder="tag title"
                                    />
                                </div>

                                <div className="form-group col-sm-12 col-lg-12 mb-3">
                                    <label htmlFor="floatingInput">Status</label>
                                    <select
                                        className="form-select custom-input my-3"
                                        onChange={handleStatusChange}
                                        value={editedMediaData?.statusid}
                                    >
                                        {statusData?.map((item, index) => (
                                            <option value={item.statusid} key={index}>{item.status}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="row">
                              <div
                                className="col-12 d-flex"
                                style={{ height: "40px", width: "120px" }}
                              >
                                <button
                                  type="button"
                                  onClick={handleDiscardClick}
                                  disabled={editLoading}
                                  style={{ height: "100%", width: "100%" }}
                                  className="btn btn-danger save-btn text-uppercase"
                                >
                                  Discard
                                </button>{" "}
                                &nbsp;
                                {editLoading ? (
                                  <div
                                    className="btn btn-primary loader-active save-btn"
                                    style={{ height: "100%", width: "100%" }}
                                  >
                                    <RiLoaderFill
                                      size={20}
                                      className="spin-animation"
                                      color="white"
                                    />
                                  </div>
                                ) : (
                                  <button
                                    type="submit"
                                    onClick={handleSubmitClick}
                                    disabled={editLoading}
                                    className="btn btn-primary save-btn text-uppercase"
                                    style={{ height: "100%", width: "100%" }}
                                  >
                                    Save
                                  </button>
                                )}
                              </div>
                            </div>
                        </div>
                }
                <hr />
            </div>
        </div>
    );
}
export default EditTag;
